import { create } from 'zustand';

import { PreferencesModalStore } from './use-preferences-modal.model';

export const usePreferencesModalStore = create<PreferencesModalStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  setOpen: (isOpen) => set({ isOpen }),
}));
